import { RouteName, useLocalizedRoutes } from "../../core/constants/route_name";
import { Auth, Route } from "../../core/interfaces/routes/interfaces";
import BannerPage from "./banner/BannerPage";
import BannerDetail from "./banner/form/BannerDetail";
import BlogDetail from "./blog/blogForm/BlogDetail";
import BlogPage from "./blog/BlogPage";
import BookDetail from "./book/BookDetail";
import ConfigurationDetail from "./configuration/ConfigurationDetail";
import HomeDetail from "./home/HomeDetail";
import ProgramDetail from "./progam/programForm/ProgramDetail";
import ProgramPage from "./progam/ProgramPage";
import SpartanDetail from "./spartan/SpartanDetail";
import SponsorDetail from "./sponsor/sponsorForm/SponsorDetail";
import SponsorPage from "./sponsor/SponsorPage";
import UserPage from "./user/UserPage";



// Hook personalizado que devuelve las rutas con traducciones
export const usePagesRoute = (): Route[] => {
    const ROUTE_NAME = useLocalizedRoutes();  // Llamamos el hook aquí, dentro del nuevo hook

    const routes: Route[] = [
        // { key: RouteName.companySetup, path: ROUTE_NAME.companySetup, to: ROUTE_NAME.companySetup, name: "Primeros pasos", Component: OnboardingPage, role: [Auth.ROLE_OUTCAST, Auth.ROLE_ADMIN] },
        { key: RouteName.home, path: ROUTE_NAME.home, to: ROUTE_NAME.home, name: "Home", Component: HomeDetail, role: [Auth.ROLE_DEVELOPER, Auth.ROLE_ADMIN, Auth.ROLE_USER, Auth.ROLE_MANAGER] },
        { key: RouteName.spartan, path: ROUTE_NAME.spartan, to: ROUTE_NAME.spartan, name: "Home", Component: SpartanDetail, role: [Auth.ROLE_DEVELOPER, Auth.ROLE_ADMIN, Auth.ROLE_USER, Auth.ROLE_MANAGER] },
        { key: RouteName.book, path: ROUTE_NAME.book, to: ROUTE_NAME.book, name: "Home", Component: BookDetail, role: [Auth.ROLE_DEVELOPER, Auth.ROLE_ADMIN, Auth.ROLE_USER, Auth.ROLE_MANAGER] },
        
        // { key: RouteName.usuarios, path: ROUTE_NAME.usuarios, to: ROUTE_NAME.usuarios, name: "Usuarios", Component: UserPage, role: [Auth.ROLE_DEVELOPER, Auth.ROLE_ADMIN, Auth.ROLE_USER, Auth.ROLE_MANAGER] },
        // { key: RouteName.company, path: ROUTE_NAME.company, to: ROUTE_NAME.company, name: "Empresa", Component: CompanyDetail, role: [Auth.ROLE_DEVELOPER, Auth.ROLE_ADMIN, Auth.ROLE_MANAGER] },
        { key: RouteName.configuration, path: ROUTE_NAME.configuration, to: ROUTE_NAME.configuration, name: "Configuración", Component: ConfigurationDetail, role: [Auth.ROLE_DEVELOPER, Auth.ROLE_ADMIN, Auth.ROLE_USER] },


        { key: RouteName.sponsor, path: ROUTE_NAME.sponsor, to: ROUTE_NAME.sponsor, name: "Sponsor", Component: SponsorPage, role: [Auth.ROLE_DEVELOPER, Auth.ROLE_ADMIN, Auth.ROLE_USER] },
        { key: RouteName.sponsorAdd, path: ROUTE_NAME.sponsorAdd, to: ROUTE_NAME.sponsorAdd, name: "Sponsor", Component: SponsorDetail, role: [Auth.ROLE_DEVELOPER, Auth.ROLE_ADMIN, Auth.ROLE_USER] },
        { key: RouteName.sponsorDetail, path: ROUTE_NAME.sponsorDetail, to: ROUTE_NAME.sponsorDetail, name: "Sponsor", Component: SponsorDetail, role: [Auth.ROLE_DEVELOPER, Auth.ROLE_ADMIN, Auth.ROLE_USER] },

        { key: RouteName.program, path: ROUTE_NAME.program, to: ROUTE_NAME.program, name: "Program", Component: ProgramPage, role: [Auth.ROLE_DEVELOPER, Auth.ROLE_ADMIN, Auth.ROLE_USER] },
        { key: RouteName.programAdd, path: ROUTE_NAME.programAdd, to: ROUTE_NAME.programAdd, name: "Program", Component: ProgramDetail, role: [Auth.ROLE_DEVELOPER, Auth.ROLE_ADMIN, Auth.ROLE_USER] },
        { key: RouteName.programDetail, path: ROUTE_NAME.programDetail, to: ROUTE_NAME.programDetail, name: "Program", Component: ProgramDetail, role: [Auth.ROLE_DEVELOPER, Auth.ROLE_ADMIN, Auth.ROLE_USER] },

        { key: RouteName.blog, path: ROUTE_NAME.blog, to: ROUTE_NAME.blog, name: "Blog", Component: BlogPage, role: [Auth.ROLE_DEVELOPER, Auth.ROLE_ADMIN, Auth.ROLE_USER] },
        { key: RouteName.blogAdd, path: ROUTE_NAME.blogAdd, to: ROUTE_NAME.blogAdd, name: "Blog", Component: BlogDetail, role: [Auth.ROLE_DEVELOPER, Auth.ROLE_ADMIN, Auth.ROLE_USER] },
        { key: RouteName.blogDetail, path: ROUTE_NAME.blogDetail, to: ROUTE_NAME.blogDetail, name: "Blog", Component: BlogDetail, role: [Auth.ROLE_DEVELOPER, Auth.ROLE_ADMIN, Auth.ROLE_USER] },

        { key: RouteName.banner, path: ROUTE_NAME.banner, to: ROUTE_NAME.banner, name: "Blog", Component: BannerPage, role: [Auth.ROLE_DEVELOPER, Auth.ROLE_ADMIN, Auth.ROLE_USER] },
        { key: RouteName.bannerAdd, path: ROUTE_NAME.bannerAdd, to: ROUTE_NAME.bannerAdd, name: "Blog", Component: BannerDetail, role: [Auth.ROLE_DEVELOPER, Auth.ROLE_ADMIN, Auth.ROLE_USER] },
        { key: RouteName.bannerDetail, path: ROUTE_NAME.bannerDetail, to: ROUTE_NAME.bannerDetail, name: "Blog", Component: BannerDetail, role: [Auth.ROLE_DEVELOPER, Auth.ROLE_ADMIN, Auth.ROLE_USER] },
    ];

    return routes;
};

// Usamos el nuevo hook personalizado
const PagesRoute = (): Route[] => {
    return usePagesRoute();
};

export default PagesRoute;



